import type { FC } from "react";
import styles from "./LoadingProgressBar.module.scss";

export const LoadingProgressBar: FC = () => {
  return <div className={styles["loading-progress-bar"]}></div>;
};
